import { LoginProvider } from '$providers/login';
import { ViewProvider } from '$providers/view';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { RecoveryPasswordChangePage } from '../recovery-password-change/recovery-password-change';

@Component({
  selector: 'page-recovery-password-code',
  templateUrl: 'recovery-password-code.html',
})
export class RecoveryPasswordCodePage {

  public cpf: any;
  public code: any;
  public dispNotificados: Array<any>;

  constructor(private navCtrl: NavController, navParams: NavParams, private loginProvider: LoginProvider,
    private viewProvider: ViewProvider) {

    this.cpf = navParams.get('cpf');
    this.dispNotificados = navParams.get('dispNotificados');
  }

  public submit() {
    if (!this.code || this.code == '') {
      this.viewProvider.showMessage('- Informe o <b>Código</b>..');
      return;
    }

    this.loginProvider.sendRecoveryCode(this.cpf, this.code).subscribe(
      (token) => {
        if (token) {
          this.navCtrl.push(RecoveryPasswordChangePage, { cpf: this.cpf, token: token });
        }
      },
      (error) => { console.error(error.message) }
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/recovery-password/recovery-password-code/recovery-password-code.ts